module.exports = __webpack_public_path__ + "img/ascend_gold33.63af8c1d.png";